<template>
  <div class="noviceGuidanceSup">
    <div class="guide-model" v-show="workbenchCurrentStepSup > 0">
      <div v-show="workbenchCurrentStepSup == item.val" :class="`guide-item guide-item${item.val}`" v-for="item in list" :key="item.val">
        <p v-html="item.title"></p>
        <el-button @click="nextStep">{{ item.btnTxt }}</el-button>
        <div class="leadArrowDown">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
        </div>
      </div>
      <img v-show="workbenchCurrentStepSup == item.val" :class="`sup-guide-img sup-guide-img${item.val}`" v-for="item in list" :key="item.val" :src="item.img" alt="">
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        list: [
          {
            title: '查看您所属企业的【启信宝评级】、【合作级别】、【产品与服务分类】等',
            val: 1,
            btnTxt: '下一步',
            img: 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/icon-oss/sup_guide_workbench_img1.png'
          },
          {
            title: '查看您的待办、已办、消息, 点击条目进入消息详情页',
            val: 2,
            btnTxt: '下一步',
            img: 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/icon-oss/sup_guide_workbench_img2.png'
          },
          {
            title: '在这里查看你可能感兴趣的商机 </br>可前往修改企业标签，使商机推荐更精准！',
            val: 3,
            btnTxt: '立即体验',
            img: 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/icon-oss/sup_guide_workbench_img3.png'
          }
        ]
      }
    },
    computed: mapState([
      'KP',
      'workbenchCurrentStepSup'
    ]),
    methods: {
      nextStep () {
        let step = this.workbenchCurrentStepSup;
        step = step + 1
        if (step > this.list.length) {
          step = 0;
          this.userExperience();
          let bodyHtml = document.querySelector('body');
          bodyHtml.style.overflowY = 'auto';
        }
        this.$store.commit("changeWorkbenchStepSup", step)
      },
      userExperience () {
        this.$axios.post('/onelink.mdata.main.api/user/userExperience', {
        }).then((res) => {
          this.setToken('isExperience',0)
          Cookies.set('isExperience',0,{domain:'.onelinkplus.com',expires:10 });
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>
<style lang="stylus">
  .noviceGuidanceSup{
    .guide-model{
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.75);
      position: fixed;
      z-index: 9999;
      top: 0px;
    }
    .leadArrowDown{
      position: absolute;
      top: -64px;
      left: 50%;
      transform: translate(-25%);
    }
    .guide-item {
      width: 360px;
      height: 180px;
      position: absolute;
      z-index: 1053;
      border: 1px solid #fff;
      border-radius: 50%;
      color: #fff;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      padding: 55px 20px 20px;
      .el-button{
        padding: 6px 20px;
        background: transparent;
        color: #fff;
      }
    }

    .guide-item1{
      left: 245px;
      top: 301px;
      width: 420px;
      height 165px;
    }

    .guide-item2{
      padding: 40px 20px 20px;
      left: 320px;
      top: 122px;
      width: 420px;
      height 125px;
      text-align: center;
      .leadArrowDown{
        position: absolute;
        top: 134px;
        left: 50%;
        transform: translate(-25%) rotate(90deg);
      }
    }

    .guide-item3{
      padding: 44px 20px 20px;
      left: auto;
      top: 385px;
      width: 420px;
      height: 165px;
      text-align: center;
      right: 449px;
      .leadArrowDown{
        position: absolute;
        left: auto;
        top: 52px;
        right: -97px;
        transform: rotate(40deg);
      }
    }

    .sup-guide-img{
      position: absolute;
    }
    .sup-guide-img1{
      left: 215px;
      top: 75px;
    }
    .sup-guide-img2{
      top: 350px;
      left: 215px;
    }
    .sup-guide-img3{
      top: 471px;
      right: 15px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/noviceGuidanceSup.vue